import React from 'react';
import AlgorithmicProblemList from './AlgorithmicProblemList';

const AlgorithmicProblemManager = () => {
    return <AlgorithmicProblemList />;
};

export default AlgorithmicProblemManager;

